"use strict";
import React from "react";
import ReactDOM from "react-dom";
import "../formatters/general";
import TypeAhead from "./ui/type_ahead";
import "../api/account";
import $ from "jquery";
import _ from "underscore";
export default React.createClass({
  search(term) {
    return $.get("/api/brokered_carriers", { page: 1, term }).then(
      (data) => data.brokered_carriers,
      _.identity
    );
  },
  componentDidMount() {
    if (this.props.autoFocus) {
      const element = ReactDOM.findDOMNode(this);
      window.setTimeout(() => {
        element.focus();
        element.select();
      });
    }
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      TypeAhead,
      {
        readOnly: this.props.readOnly,
        remoteSearch: this.search,
        display: this.brokeredCarrierDisplay,
        placeHolder: "Carrier Name",
        className: "carrier-setter__typeahead",
        isDroppable: true,
        selectedItem: this.props.brokeredCarrier,
        onSelectItem: this.props.onSelectBrokeredCarrier,
        onClearSelectedItem: this.props.onClearBrokeredCarrier,
        onFocus: this.selectAll
      }
    );
  },
  brokeredCarrierDisplay: function(brokeredCarrier) {
    let html = brokeredCarrier.name;
    const address = brokeredCarrier.tms_payment_address;
    const dot = brokeredCarrier.dot_number;
    const mc = brokeredCarrier.mc_number;
    const carrierNumber = brokeredCarrier.code;
    if (carrierNumber) {
      html += `<br> Number: ${carrierNumber} `;
    } else {
      html += "<br> ";
    }
    if (dot && mc) {
      html += "DOT: " + dot + " MC: " + mc;
    } else if (dot) {
      html += "DOT: " + dot;
    } else if (mc) {
      html += "MC: " + mc;
    }
    if (address) {
      html += "<br>";
      if (address.city && address.state) {
        html += `${address.city}, ${address.state}`;
      } else {
        if (address.city) {
          html += address.city;
        }
        if (address.state) {
          html += address.state;
        }
      }
    }
    return html;
  },
  selectAll(event) {
    event.target.select();
  }
});
